import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchPartTwoVehicleInformationType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartTwoVehicleInformation/patchPartTwoVehicleInformation.type';
import { patchPartTwoVehicleInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPartTwoVehicleInformation/patchPartTwoVehicleInformationFunction';

export const patchPartTwoVehicleInformationOption = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchPartTwoVehicleInformationType
> => ({
  mutationKey: ['patch-part_two-vehicle-information'],
  mutationFn: ({ id, data, damaged_id }: PatchPartTwoVehicleInformationType) =>
    patchPartTwoVehicleInformationFunction({ damaged_id, data, id }),
});
